import { render, staticRenderFns } from "./LeadsMark.vue?vue&type=template&id=7e38ca72&scoped=true"
import script from "./LeadsMark.vue?vue&type=script&lang=js"
export * from "./LeadsMark.vue?vue&type=script&lang=js"
import style0 from "./LeadsMark.vue?vue&type=style&index=0&id=7e38ca72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e38ca72",
  null
  
)

export default component.exports